export default "__VITE_ASSET__Bopy92HJ__"